import { combineReducers } from 'redux';
import authReducer from './login';
import portfolio from './portfolio';
import authentication from './authentication';
import newPurchase, { InitStateForPurchaseType } from './newPurchase';
import redemptionReducer, { RedemptionSchemeOptionsType } from './redemption';
import sipCancelReducer, { SipCancelReducerType } from './sipCancel';

export interface RootStateType {
    authReducer: any;
    router: any;
    portfolio: any;
    authentication: any;
    newPurchase: InitStateForPurchaseType;
    redemptionReducer: Array<RedemptionSchemeOptionsType>;
    sipCancelReducer: SipCancelReducerType;
}

export const rootReducer = (history: any) =>
    combineReducers({
        router: history,
        authReducer,
        portfolio,
        authentication,
        newPurchase,
        redemptionReducer,
        sipCancelReducer,
    });

export type RootState = ReturnType<typeof rootReducer>;
